module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAABFUlEQVRYR+2YPUoEQRSEq/ACi6cQBFNFExNPYKCBiUkPcwh/r2DUPROYGJibiLDJxpvqEQQR1gM078nABCLig24WluVN1FC8ovi6oLuHqPy6rtsRkWcACxE5bNv2o8aSNcPDbErpUlVvhjXJsxDCQ41ndaAY4zWAqzHQeQjh3gP9JOCErD44ISdkEbB075ATsghY+vp3KKW0D+BYRDYsGn/pJPcA7I6n/YuIvBb6ZJKPjDEuAExKTJYw8z4EegOwtQTzEss5+77fzDkfkCzaMgCnAE7GLbtT1WlJEpJZVWd+Y7ToOSEn5M+g3x1Y/8PVar2lOyEnZBGw9FXs0AWA25X5YZVS2lbVJwBfAI6apvm0qP6nfwNNT9BKXz7cJAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common-img/add@2x.png
// module id = /06v
// module chunks = 17